// success messages
export const DIMENSION_CREATED = 'Dimension saved';
